import React from "react";
import { Sliders } from "react-feather";
import { Row, Col, Progress, Modal, ModalBody } from "reactstrap";

const LinearProgressWithLabel = () => (
  <Row>
    <Col lg="12">
      <Progress animated value={100} />
    </Col>
  </Row>
);

const Ranking = ({ open, handleClose }) => {
  return (
    <Modal onClosed={handleClose} isOpen={open} centered size="md">
      <ModalBody>
        <Row className="align-self-center text-center">
          <Col lg={12} sm={12} md={12} className="p-2">
            <span>
              <Sliders size={30} />
            </span>
          </Col>
          <Col lg={12} sm={12} md={12} className="p-2">
            <h5>
              We are rating and ranking your videos now based on your selection
            </h5>
          </Col>
          <Col lg={12} sm={12} md={12} className="p-2">
            <LinearProgressWithLabel />
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default Ranking;
